import { useMediaQuery } from 'react-responsive';
import { theme } from '@fiverr-private/theme';

export const useBreakpointSm = () => useMediaQuery({ query: theme.breakpoints.sm });
export const useBreakpointMd = () => useMediaQuery({ query: theme.breakpoints.md });
export const useBreakpointLg = () => useMediaQuery({ query: theme.breakpoints.lg });
export const useBreakpointXl = () => useMediaQuery({ query: theme.breakpoints.xl });
export const useBreakpointXxl = () => useMediaQuery({ query: theme.breakpoints.xxl });
